export const setCookie = (name: string, value: string, expDays?: number) => {
  const date = new Date();
  if (expDays) {
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + expDays);
  }
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
    value
  )}; path=/; expires=${expDays ? date.toUTCString() : ''}`;
};

export const getCookie = (name: string) => {
  const value =
    document.cookie
      .split('; ')
      .find((row) => row.startsWith(name))
      ?.split('=')[1] ?? '';
  return decodeURIComponent(value);
};

export const deleteCookie = (name: string) => {
  setCookie(name, '', -1);
};
